import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { isNullOrUndefined } from 'util';
import { CLPUser, LoadUserObj, LoadUserResponse } from '../../../../models/clpuser.model';
import { ClpUserFilterResponse } from '../../../../models/report.model';
import { ReportService } from '../../../../services/report.service';
import { UtilityService } from '../../../../services/shared/utility.service';

@Component({
    selector: 'user-filter',
    templateUrl: './user-filter.component.html',
    styleUrls: ['./user-filter.component.css']
})
export class UserFilterComponent implements OnInit {
    encryptedUser: string = '';
    loadUserData: LoadUserObj = <LoadUserObj>{};
    @Input() clpUserFilter: ClpUserFilterResponse;
    @Input() user: CLPUser;
    @Output() clpUsersList: EventEmitter<string[]> = new EventEmitter<string[]>();
    @Output() selUser: EventEmitter<number> = new EventEmitter<number>();
    @Output() strListClpUsers: EventEmitter<string> = new EventEmitter<string>();
    @Output() reloadDefaultReoprt: EventEmitter<boolean> = new EventEmitter<boolean>();
    userFilterForm: FormGroup;
    strClpUsers: string;
    isLoad: boolean = true;
    constructor(private fb: FormBuilder,
        private _utilityService: UtilityService,
        private _reportService: ReportService,) {
    }

    ngOnInit(): void {
        this.loadPage();
    }

    async loadPage() {
        this.userFilterForm = this.prepareUserFilterForm();
        if (!isNullOrUndefined(localStorage.getItem("token"))) {
            this.encryptedUser = localStorage.getItem("token");
            if (!isNullOrUndefined(this.user) && !isNullOrUndefined(this.clpUserFilter)) {
                await this.getUserList(false);
            } 
        }
    }


    prepareUserFilterForm(): FormGroup {
        return this.fb.group({
            officeCode: new FormControl(this.user?.officeCode),
            teamCode: new FormControl(this.user?.teamCode),
            ddUser: new FormControl(this.user?.cLPUserID),
            isOfficedChecked: new FormControl(false),
            isTeamChecked: new FormControl(false),
        });
    }

    async onchangeTeamOffice() {
        this.userFilterForm.controls.ddUser.setValue(0);
        await this.getUserList();
        this.selUser.emit(this.userFilterForm.controls.ddUser.value);
    }



    async getUserList(firstLoad: boolean = true) {
        this.copyLoadUserObj();
        await this._reportService.getUserList(this.encryptedUser, this.loadUserData)
            .then(async (result: LoadUserResponse) => {
                if (result) {
                    const response = UtilityService.clone(result);
                    if (result.userDD && result.userDD.length > 0)
                        this.clpUserFilter.userDD = response?.userDD;
                    this.clpUsersList.emit(response?.clpUsersList.split(','));
                    this.strClpUsers = response?.clpUsersList;
                    this.strListClpUsers.emit(this.strClpUsers)
                    if (!firstLoad) {
                        this.userFilterForm.controls['ddUser'].setValue(this.user?.cLPUserID)
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }

    copyLoadUserObj() {
        this.loadUserData.clpCompanyId = this.user.cLPCompanyID;
        this.loadUserData.clpUserId = this.user.cLPUserID;
        this.loadUserData.selectedUserId = this.userFilterForm.controls.ddUser.value;
        this.loadUserData.officeCode = this.userFilterForm.controls.officeCode.value;
        this.loadUserData.teamCode = this.userFilterForm.controls.teamCode.value;
        this.loadUserData.isOfficeMy = this.clpUserFilter?.isMyOffice;
        this.loadUserData.isTeamMy = this.clpUserFilter?.isMyTeam;
        this.loadUserData.isOfficedChecked = this.userFilterForm.controls.isOfficedChecked.value;
        this.loadUserData.isTeamChecked = this.userFilterForm.controls.isTeamChecked.value;
        this.loadUserData.blnSetUser = false;
    }

    async onUserChange() {
        //this.userFilterForm.controls.ddUser.value > 0 ? this.strListClpUsers.emit(this.userFilterForm.controls.ddUser.value) : !isNullOrUndefined(this.strClpUsers) ? this.strListClpUsers.emit(this.strClpUsers) : this.strListClpUsers.emit(this.clpUserFilter.userDD.map(model => model.id).join(','));
        this.selUser.emit(this.userFilterForm.controls.ddUser.value);
        if (this.userFilterForm.controls.ddUser.value > 0) {
            this.strListClpUsers.emit(this.userFilterForm.controls.ddUser.value)
        }
        else if (this.userFilterForm.controls.ddUser.value == 0) {
            await this.getUserList();
            this.strListClpUsers.emit(this.strClpUsers)
        }
        else {
            this.strListClpUsers.emit(this.clpUserFilter.userDD.map(model => model.id).join(','));
        }
    }

    //async userFiltersReset() {
    //    this.isLoad = true;
    //    if (!isNullOrUndefined(this.user) && !isNullOrUndefined(this.clpUserFilter)) {
    //        this.clpUsersList = new EventEmitter<string[]>();
    //        this.userFilterForm.controls['teamCode'].setValue(this.user?.teamCode)
    //        this.userFilterForm.controls['officeCode'].setValue(this.user?.officeCode)
    //        await this.getUserList();
    //        //this.isLoad ? this.userFilterForm.controls.ddUser.setValue(this.user?.cLPUserID) : this.userFilterForm.controls.ddUser.setValue(0);
    //        //this.isLoad = false;
    //        this.addTimeout(() => {
    //            this.userFilterForm.controls.ddUser.setValue(this.user?.cLPUserID)
    //            this.addTimeout(() => {
    //                this.reloadDefaultReoprt.emit(true);
    //            }, 100)
    //        }, 100)
    //    }
    //}

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

    ngOnDestroy() {
        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
    }
}
